module.exports = __webpack_public_path__ + "static/media/Inter-Medium.95b8a989.woff";